// src/pages/platform/GameHouse.tsx

import React from "react";

import {
  Link,
} from "react-router-dom";

import "./PlatformPages.css";


// =====================================================
// GAMES
// =====================================================

const games = [
  {
    name: "Fasoor",
    symbol: "♣",
    description:
      "A strategic card game of captures, combinations, Soors, and competitive scoring.",
    status: "PLAY NOW",
    available: true,
    guide: "/guides/fasoor",
  },
  {
    name: "Tika",
    symbol: "♦",
    description:
      "A new P-ARENA card game experience currently being prepared for the Game House.",
    status: "COMING SOON",
    available: false,
    guide: "/guides/tika",
  },
  {
    name: "Bitruno",
    symbol: "♠",
    description:
      "Another competitive card game coming to the growing P-ARENA collection.",
    status: "COMING SOON",
    available: false,
    guide: "/guides/bitruno",
  },
  {
    name: "Charwali",
    symbol: "♥",
    description:
      "A future P-ARENA title designed for social and competitive card-game play.",
    status: "COMING SOON",
    available: false,
    guide: "/guides/charwali",
  },
  {
    name: "Fiskoot",
    symbol: "♣",
    description:
      "More variety is coming to the P-ARENA Game House with Fiskoot.",
    status: "COMING SOON",
    available: false,
    guide: "/guides/fiskoot",
  },
];


// =====================================================
// GAME HOUSE
// =====================================================

const GameHouse: React.FC = () => {

  return (
    <main className="platform-page">

      {/* ============================================= */}
      {/* HERO                                          */}
      {/* ============================================= */}

      <section className="platform-hero">

        <div className="platform-hero-glow" />

        <div className="platform-hero-content">

          <nav
            className="platform-breadcrumb"
            aria-label="Breadcrumb"
          >
            <Link to="/">
              P-ARENA
            </Link>

            <span>/</span>

            <strong>
              Game House
            </strong>
          </nav>


          <div className="platform-emblem">
            ♠
          </div>

          <p className="platform-eyebrow">
            P-ARENA
          </p>

          <h1>
            Game House
          </h1>

          <p className="platform-hero-description">
            Discover the games of P-ARENA.
            Play available titles today and
            explore the games joining the
            platform next.
          </p>

        </div>

      </section>


      {/* ============================================= */}
      {/* CONTENT                                       */}
      {/* ============================================= */}

      <div className="platform-content">

        <section className="platform-section">

          <div className="platform-section-heading">

            <span>
              01
            </span>

            <div>
              <p>
                THE COLLECTION
              </p>

              <h2>
                Choose Your Game
              </h2>
            </div>

          </div>


          <div className="game-house-grid">

            {games.map(
              (game) => (

                <article
                  key={game.name}
                  className={`
                    game-house-card
                    ${
                      game.available
                        ? "available"
                        : "coming-soon"
                    }
                  `}
                >

                  <div className="game-house-card-top">

                    <span className="game-house-symbol">
                      {game.symbol}
                    </span>

                    <span
                      className={`
                        game-house-status
                        ${
                          game.available
                            ? "live"
                            : ""
                        }
                      `}
                    >
                      {game.status}
                    </span>

                  </div>


                  <h3>
                    {game.name}
                  </h3>

                  <p>
                    {game.description}
                  </p>


                  <div className="game-house-actions">

                    {game.available ? (

                      <Link
                        to="/lobby"
                        className="platform-primary-button"
                      >
                        Play Fasoor
                      </Link>

                    ) : (

                      <span className="platform-disabled-button">
                        Coming Soon
                      </span>

                    )}


                    <Link
                      to={game.guide}
                      className="platform-text-link"
                    >
                      Game Guide →
                    </Link>

                  </div>

                </article>

              )
            )}

          </div>

        </section>


        {/* =========================================== */}
        {/* MODES                                       */}
        {/* =========================================== */}

        <section className="platform-section">

          <div className="platform-section-heading">

            <span>
              02
            </span>

            <div>
              <p>
                PLAY YOUR WAY
              </p>

              <h2>
                One Arena. Different Opponents.
              </h2>
            </div>

          </div>


          <div className="platform-feature-grid">

            <article>
              <span>
                AI
              </span>

              <h3>
                Play with AI
              </h3>

              <p>
                Enter a game against a
                computer-controlled P-ARENA
                opponent.
              </p>
            </article>


            <article>
              <span>
                02
              </span>

              <h3>
                Play with Friends
              </h3>

              <p>
                Connect with another player and
                compete together through the
                supported multiplayer experience.
              </p>
            </article>


            <article>
              <span>
                ∞
              </span>

              <h3>
                Play Online
              </h3>

              <p>
                Match with other players as
                P-ARENA's online community and
                multiplayer features grow.
              </p>
            </article>

          </div>

        </section>


        <section className="platform-cta">

          <div className="platform-suits">
            ♠ ♥ ♦ ♣
          </div>

          <p className="platform-eyebrow">
            ENTER THE ARENA
          </p>

          <h2>
            Ready to Play?
          </h2>

          <p>
            Fasoor is available now in the
            P-ARENA Game House.
          </p>

          <Link
            to="/lobby"
            className="platform-primary-button"
          >
            Play Fasoor
          </Link>

        </section>

      </div>

    </main>
  );
};


export default GameHouse;